class SendOrderQuoteManagement extends HTMLElement {
    constructor() {
        super();

        this.sendOrderQuoteInfo = JSON.parse(localStorage.getItem('br_sendOrderQuote'));
        this.sendOrderQuoteStatusInterval = null;
        this.loadingModal = this.querySelector('.br-loadingAsyncModal');
        this.errorMessageToast = this.querySelector('.br-messageToast.-error');

        this.initializeSendOrderQuotePidListener();
        //this.initializeDropdownListener();
    }

    /* --------------------------- LISTENERS - METHODS -------------------------- */

    initializeSendOrderQuotePidListener() {
        if (!this.sendOrderQuoteStatusInterval && this.sendOrderQuoteInfo !== null) {
            this.initializeSendOrderQuoteStatusInterval();
        }

        window.addEventListener('send-order-quote', () => {
            this.sendOrderQuoteInfo = JSON.parse(localStorage.getItem('br_sendOrderQuote'));
            if (!this.sendOrderQuoteStatusInterval && this.sendOrderQuoteInfo !== null) {
                this.initializeSendOrderQuoteStatusInterval();
            }
        });
    }

    /* --------------------------- INTERVAL - METHODS --------------------------- */

    initializeSendOrderQuoteStatusInterval() {
        this.loadingModal.style.display = 'flex';
        this.sendOrderQuoteImportStatusManagement();

        this.sendOrderQuoteStatusInterval = setInterval(async () => {
            this.sendOrderQuoteImportStatusManagement();
        }, 10000);
    }

    clearSendOrderQuoteStatusInterval() {
        clearInterval(this.sendOrderQuoteStatusInterval);
        this.sendOrderQuoteStatusInterval = null;
    }

    /* --------------------------------- METHODS -------------------------------- */

    async sendOrderQuoteImportStatusManagement() {
        const importInfo = await this.handleSendOrderQuoteAsyncStatus();

        if (importInfo.errors && Object.keys(importInfo.errors).length && importInfo.status != 'done') {
            this.clearSendOrderQuoteStatusInterval();
            this.parseErrors(importInfo.errors);
            return;
        }

        if (importInfo.status === 'done') {
            this.clearSendOrderQuoteStatusInterval();
            this.loadCart(importInfo);
        }
    }

    parseErrors(errors) {
        this.loadingModal.style.display = 'none';
        this.errorMessageToast.style.display = 'inherit';
        setTimeout(() => {
            this.errorMessageToast.style.display = 'none';
        }, 3000);
        this.sendOrderQuoteInfo = null;
        localStorage.removeItem('br_sendOrderQuote');
    }

    async loadCart(data) {
        const cart = localStorage.getItem('br_cartProducts')
            ? JSON.parse(localStorage.getItem('br_cartProducts'))
            : null;

        const arrayQuoteProducts = [];
        const arrayOrderProducts = [];

        let newCartArray = [];

        if (cart) {
            for (const item of cart.items) {
                if (item.isQuote) {
                    arrayQuoteProducts.push(item);
                } else {
                    arrayOrderProducts.push(item);
                }
            }
        }

        this.loadingModal.style.display = 'none';
        localStorage.removeItem('br_sendOrderQuote');

        const params = [];

        if (data.quote && data.quote.data) {
            if (data.quote.data.isOk != undefined) {
                params.push(`quoteStatus=${data.quote.data.isOk}`);
            } else {
                if (data.quote.errors && data.quote.errors.length > 0) {
                    newCartArray = [...JSON.parse(JSON.stringify(newCartArray)), ...arrayQuoteProducts];
                    this.parseErrors(data.quote.errors);
                }
            }
            if (data.quote.data.SalesQuotationNumber != undefined) {
                params.push(`quoteNumber=${data.quote.data.SalesQuotationNumber}`);
            }
        } else {
            newCartArray = [...JSON.parse(JSON.stringify(newCartArray)), ...arrayQuoteProducts];
            if (data.quote.errors && data.quote.errors.length > 0) {
                this.parseErrors(data.quote.errors);
            }
        }

        if (data.order && data.order.data) {
            if (data.order.data.isOk != undefined) {
                params.push(`orderStatus=${data.order.data.isOk}`);
            } else {
                if (data.quote.errors && data.quote.errors.length > 0) {
                    newCartArray = [...JSON.parse(JSON.stringify(newCartArray)), ...arrayOrderProducts];
                    this.parseErrors(data.quote.errors);
                }
            }
            if (data.order.data.orderNumber != undefined && data.order.data.orderNumber) {
                params.push(`orderNumber=${data.order.data.orderNumber}`);
            }
        } else {
            newCartArray = [...JSON.parse(JSON.stringify(newCartArray)), ...arrayOrderProducts];
            if (data.quote.errors && data.quote.errors.length > 0) {
                this.parseErrors(data.quote.errors);
            }
        }

        if (arrayOrderProducts.length > 0) {
            params.push(`orderQuantity=${arrayOrderProducts.length}`);
        }

        if (arrayQuoteProducts.length > 0) {
            params.push(`quoteQuantity=${arrayQuoteProducts.length}`);
        }

        if (newCartArray.length > 0) {
            const newCart = {
                ...cart,
                items: newCartArray,
            };
            localStorage.setItem('br_cartProducts', JSON.stringify(newCart));
        } else {
            localStorage.removeItem('br_cartProducts');
        }

        if (params.length > 0) {
            setTimeout(() => {
                this.sendOrderQuoteInfo = null;
                window.location.href = `/cart#thank-you?${params.join('&')}`;
                window.location.reload();
            }, 1000);
        }
    }

    /* ------------------------------ HTTP REQUEST ------------------------------ */

    async handleSendOrderQuoteAsyncStatus() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'GET',
            headers: headers,
        };

        const response = await fetch(
            `/apps/berardi/carts/submit/${this.sendOrderQuoteInfo.pid}/status`,
            requestOptions,
        );
        const data = await response.json();
        return data;
    }
}

customElements.define('send-order-quote-management', SendOrderQuoteManagement);
